module.exports = __webpack_public_path__ + "media/images/img-warrior-51d2ad58ff17e1ace182737cc7c28939.svg";